import script from "./Pane7.vue?vue&type=script&setup=true&lang=js"
export * from "./Pane7.vue?vue&type=script&setup=true&lang=js"

import "./Pane7.vue?vue&type=style&index=0&id=d1412fd6&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1412fd6"]])

export default __exports__